import React, { Component } from 'react';
import { connect } from 'react-redux';

const checkServizio = servizio => (WrappedComponent) => {
    class Wrapper extends Component {
        render() {
            const { servizioAttivo, ...others } = this.props;
            return (
                <WrappedComponent {...others} servizioAttivo={servizioAttivo} />
            );
        }
    }

    const mapStoreToProps = (store) => {
        const serviziUfficio = store.utente.ufficioSelezionato.Servizi;

        return {
            servizioAttivo: !!serviziUfficio.find(x => x.CodiceServizio === servizio && x.StatoAttivazione === 3),
            accessoNonConsentito: !!!serviziUfficio.find(x => x.CodiceServizio === servizio) || !!!serviziUfficio.find(x => x.CodiceServizio === servizio && (x.StatoAttivazione == 3 || x.StatoAttivazione == 4))
        };
    };

    Wrapper.displayName = `checkServizio(${WrappedComponent.displayName || WrappedComponent.name})`;

    return connect(mapStoreToProps, null, null, { pure: false, withRef: true })(Wrapper);
};

export default checkServizio;
